
























import { Component, Vue } from 'vue-property-decorator'

@Component
export default class TestD extends Vue {
    logs: {msg: string}[] = []

    insterval: NodeJS.Timer

    mounted () {
        this.insterval = setInterval(() => {
            const log = {
                msg: (Math.random() * 1000).toFixed(0) + ' - ' + 'Log Testing'
            }
            this.logs.push(log)
            setTimeout(() => {
                if (this.$refs.logsContainer instanceof Element) {
                    this.$refs.logsContainer.scrollTo(0, this.$refs.logsContainer.scrollHeight)
                }
            }, 1)
        }, 1500)
    }

    beforeDestroy () {
        clearInterval(this.insterval)
    }
}
